<form #createForm="ngForm" class="mb-4 grid grid-cols-2 gap-4">
  <mat-form-field class="w-full">
    <mat-label class="block text-gray-700">Desde/Hasta</mat-label>
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
      <input matStartDate formControlName="start" placeholder="Fecha Inicio">
      <input matEndDate formControlName="end" placeholder="Fecha Fin">
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <!-- <mat-form-field appearance="fill" class="col-span-1">
    <mat-label>Desde</mat-label>
    <input matInput [matDatepicker]="pickerStart" [(ngModel)]="currentCreateSubRouteItinerary.datetimeStart" name="dateStart" required>
    <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
    <mat-datepicker #pickerStart></mat-datepicker>
  </mat-form-field>
  
  <mat-form-field appearance="fill" class="col-span-1">
    <mat-label>Hasta</mat-label>
    <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="currentCreateSubRouteItinerary.datetimeEnd" name="dateEnd" required>
    <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
    <mat-datepicker #pickerEnd></mat-datepicker>
  </mat-form-field> -->

  <mat-form-field appearance="fill" class="col-span-1">
    <mat-label>Días</mat-label>
    <mat-select
      [(ngModel)]="currentCreateSubRouteItinerary.days"
      name="days" multiple required>
      <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" class="col-span-1">
    <mat-label>Acción</mat-label>
    <mat-select [(ngModel)]="currentCreateSubRouteItinerary.action"
      name="actions"
      multiple required>
      <mat-option *ngFor="let action of actions" [value]="action">
        {{action | transloco }}
      </mat-option>
    </mat-select>
  </mat-form-field>                
</form>
